export default __webpack_public_path__ + "static/media/pl_nurse3.93f5e7cb.png";